import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="min-h-[60vh] flex items-center justify-center bg-drosun-light">
      <div className="text-center px-5">
        <p className="font-display text-7xl text-drosun-red">404</p>
        <h1 className="mt-4 font-display uppercase text-3xl text-drosun-text">Pagina non trovata</h1>
        <p className="mt-3 text-drosun-muted">La pagina cercata non esiste o è stata spostata.</p>
        <Link to="/" className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-drosun-red hover:bg-drosun-redHover text-white font-bold uppercase tracking-wide rounded-md transition-colors">Torna alla Home</Link>
      </div>
    </section>
  );
}
